import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["count", "icon", "highlightIcon", "title"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import Icon from 'components/Icon';
import { TooltipPill } from 'components/Pill';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function TooltipPillWithCount(props) {
  var count = props.count,
    icon = props.icon,
    highlightIcon = props.highlightIcon,
    title = props.title,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsxs(TooltipPill, _objectSpread(_objectSpread({}, otherProps), {}, {
    title: title,
    icon: highlightIcon ? icon : undefined,
    children: [!highlightIcon && icon && /*#__PURE__*/_jsx(Icon, {
      vAlign: true,
      dimmed: true,
      name: icon,
      scale: 0,
      mr: "xxs"
    }), count]
  }));
}
export default TooltipPillWithCount;